import { useForm } from "react-hook-form";
import { ReserveHolderAbi, contractAddresses } from "@meta";
import {
  useNotificationContext,
  useWingsContractWrite,
  Typography,
  Card,
  MyFormProvider,
  FlexCol,
  Button,
} from "@shared";
import { useReadContract } from "wagmi";

export const SetClaimer: React.FC = () => {
  const { showNotification } = useNotificationContext();
  const methods = useForm();
  const { reset, handleSubmit } = methods;

  const { writeContractAsync: setClaimer, isPending: isSettingClaimer } =
    useWingsContractWrite();

  const onSubmit = async (data: any) => {
    await setClaimer(
      {
        abi: ReserveHolderAbi,
        address: contractAddresses.ReserveHolder,
        functionName: "setClaimer",
        args: [data.claimerAddress],
      },
      {
        onSuccess: () => {
          reset();
          showNotification({
            status: "success",
            content: <Typography>Claimer set successfully</Typography>,
          });
        },
      }
    );
  };

  const { data: claimer } = useReadContract({
    abi: ReserveHolderAbi,
    address: contractAddresses.ReserveHolder,
    functionName: "claimer",
  });

  return (
    <Card className="w-2/3" hasBorder>
      <MyFormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <FlexCol className="w-full p-4 gap-4">
          <Typography>
            Current claimer: <strong> {claimer}</strong>
          </Typography>
          <Typography>Reserve Holder / setClaimer /</Typography>
          <FlexCol className="gap-3">
            <input
              {...methods.register("claimerAddress")}
              placeholder="Claimer Address"
              className="input input-bordered w-full"
            />
            <Button type="submit" loading={isSettingClaimer}>
              Set Claimer
            </Button>
          </FlexCol>
        </FlexCol>
      </MyFormProvider>
    </Card>
  );
};
